import React, { useContext, useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { RenderNodeContext } from './RenderNodeContext';

type ScrollToTopProps = {
	needToScroll?: (oldPathame: string, newPathname: string) => boolean;
	scrollTo0?: boolean;
};

const ScrollToTop: React.FC<ScrollToTopProps> = ({ children, needToScroll, scrollTo0 }) => {
	const { pathname } = useLocation();
	const oldPathname = useRef(pathname);
	const scrollTo = useContext(RenderNodeContext);

	useEffect(() => {
		const noScroll = pathname.indexOf('/f/') > -1;
		if (!noScroll && (!needToScroll || needToScroll(oldPathname.current, pathname))) {

			if (scrollTo && !scrollTo0) {
				const bodyRect = document.body.getBoundingClientRect();
				const elemRect = scrollTo.getBoundingClientRect();
				const offset = elemRect.top - bodyRect.top;

				window.scrollTo(0, offset);
			} else {
				window.scrollTo(0, 0);
			}
		}

		oldPathname.current = pathname;
	}, [needToScroll, pathname]);

	return <>{children}</>;
};

export { ScrollToTop };
